import { Injectable } from "@angular/core";
import { SwUpdate } from "@angular/service-worker";

@Injectable({
  providedIn: "root",
})
export class UpdatePwaServiceService {
  constructor(public updates: SwUpdate) {}

  public checkForUpdates(): void {
    this.updates.versionUpdates.subscribe((event) => {
      if (event.type === "VERSION_READY") {
        document.location.reload();
      }
    });
  }
}
